import { useState, useEffect } from "react";

export default function useWindowSize() {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { size };
}

function useWindowHeight(threshold?: number) {
  const [height, setHeight] = useState(() => window.innerHeight);
  const [isBelowThreshold, setIsBelowThreshold] = useState(
    threshold ? window.innerHeight < threshold : false,
  );

  useEffect(() => {
    const handleResize = () => {
      const h = window.innerHeight;
      setHeight(h);
      if (threshold !== undefined) {
        setIsBelowThreshold(h < threshold);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [threshold]);

  return { height, isBelowThreshold };
}

export { useWindowHeight, useWindowSize };
